export const CrossIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2537_8417)">
      <path
        d="M0.704505 21.7046C0.265165 22.144 0.265165 22.8563 0.704505 23.2956C1.14384 23.735 1.85616 23.735 2.2955 23.2956L12 13.5911L21.7045 23.2957C22.1439 23.735 22.8562 23.735 23.2955 23.2957C23.7349 22.8563 23.7349 22.144 23.2955 21.7047L13.591 12.0001L23.2954 2.29568C23.7348 1.85634 23.7348 1.14403 23.2954 0.704688C22.8561 0.265348 22.1438 0.265348 21.7044 0.704688L12 10.4091L2.29559 0.704722C1.85625 0.265382 1.14394 0.265382 0.704596 0.704722C0.265257 1.14406 0.265257 1.85637 0.704596 2.29571L10.409 12.0001L0.704505 21.7046Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2537_8417">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
